// 商品詳細のtableをスマホ時に横スクロールにするための処理
function wrapWideTables() {
  document.querySelectorAll(".product__description table").forEach(function (table) {
    const parent = table.parentElement;

    // すでに .table_scroll にラップされているならスキップ
    if (parent.classList.contains("table_scroll")) return;

    // 一時的に幅チェック
    const tableWidth = table.scrollWidth;
    const parentWidth = parent.clientWidth;

    if (tableWidth > parentWidth) {
      const wrapper = document.createElement("div");
      wrapper.className = "table_scroll";
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  });
}

// 初回読み込み時
document.addEventListener("DOMContentLoaded", wrapWideTables);

// ウィンドウリサイズ時にも再チェック
window.addEventListener("resize", function () {
  // 一度すべて元に戻してから再判定（多重ラップ防止）
  document.querySelectorAll(".product__description .table_scroll").forEach(function (wrapper) {
    const table = wrapper.querySelector("table");
    if (table) {
      wrapper.parentElement.insertBefore(table, wrapper);
      wrapper.remove();
    }
  });

  // 再度テーブル幅チェック
  wrapWideTables();
});